@if (message.title) {
  <h2 mat-dialog-title>
    {{message.title}}
  </h2>
}
<mat-dialog-content cdkFocusInitial>
  <div class="dialog-content">
    <span class="material-symbols-rounded" [class]="message.type">{{getIconByMessageType()}}</span>
    <div>
      <div class="text" [innerHTML]="modalMessage">
      </div>
      <div class="additional-info" innerHTML="{{message.info}}">
        <!-- {{message.info}} -->
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @for (button of message.buttons; track button; let i = $index) {
    <button mat-raised-button mat-dialog-close
      [color]="getButtonColor(i, button)"
      (click)="close(button)"
    [style.background-color]="getButtonBgColor(i, button)">{{getButtonText(i, button)}}</button>
    <!--<button mat-raised-button color="primary" mat-dialog-close *ngSwitchCase="'ok'" (click)="close(button)" i18n="@@UI.Label.OK">OK</button>
    <button mat-raised-button color="accent" mat-dialog-close *ngSwitchCase="'no'" (click)="close(button)" i18n="@@UI.Label.No">Nem</button>
    <button mat-raised-button color="primary" mat-dialog-close *ngSwitchCase="'yes'" (click)="close(button)" i18n="@@UI.Label.Yes">Igen</button>
    <button mat-raised-button color="accent" mat-dialog-close *ngSwitchCase="'delete'" (click)="close(button)" i18n="@@UI.Label.Delete">Törlés</button>
    <button mat-raised-button color="accent" mat-dialog-close *ngSwitchCase="'close'" (click)="close(button)" i18n="@@UI.Label.Close">Bezár</button>-->
  }
  @if (message.footerInfo && message.footerInfo.length > 0) {
    <div class="footer-info">
      {{message.footerInfo}}
    </div>
  }
</mat-dialog-actions>
